import React from 'react';
import Typography from '@material-ui/core/Typography';
import energy_number_relation from '../../../assets/images/numerology/numerologyImage.png'
import { sendData } from '../../../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class Numerology extends React.Component {

    componentDidMount() {
        sendData('', 'numerology' , 'viewed');
    }

    render() {
    return (
        <div>
                <div component="p" style={{ textAlign: 'center',paddingLeft: '15px', paddingRight: '10px',
                                            color: '#e0515d', marginTop: '100px', marginBottom: '20px',
                                            fontSize: '40px', fontFamily: 'balthazar,serif'}}>
                   <FormattedMessage id="whatIsNum"
                                    defaultMessage="What Is Numerology?"
                                /> 
                                
                </div>
                
                <div style={{textAlign: 'center', color: '#fefefe', backgroundColor: 'transparent',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem',
                                            fontWeight: '400', width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)',
                                            position: 'relative', paddingLeft: '15px', paddingRight: '10px'
                                }}>
                    <FormattedMessage id="numDesc"
                                    defaultMessage="Numbers hold value, both numerical and spiritual. Numerology, in its simplest terms, is the relationship between a number and its mystical nature on both an individual and worldly level. Numerology is also the study of the numerical value of the alphabet."
                                />
                </div>

                <Typography style={{textAlign: 'center' , paddingLeft: '15px', paddingRight: '10px',
                                    marginBottom: '20px', fontSize: '2rem',
                                    fontWeight: '300', letterSpacing: '.02em',
                                    textTransform: 'uppercase', fontFamily: 'khand,sans-serif', 
                                    marginTop: '20px', color: '#e0515d'}}>
                    <FormattedMessage id="histNumTitle"
                                    defaultMessage="HISTORY OF NUMEROLOGY"
                                />
                    
                </Typography>
                <div style={{textAlign: 'center', color: '#fefefe', backgroundColor: 'transparent',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem',
                                            fontWeight: '400', width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)',position: 'relative', paddingLeft: '15px', paddingRight: '10px'
                                }}>
                    <FormattedMessage id="histNumDesc"
                                    defaultMessage="While the actual word numerology wasn't recorded in English until 1907, numerological ideas have been around for centuries. Some of the earliest records of numerology appeared in ancient Egypt and Babylon along with China, Rome, Japan, and Greece. However, it was the Greek philosopher Pythagoras who became the father of numerology.Pythagoras was hailed in his day for being a brilliant philosopher and mathematician. While much of Pythagoras' life is shrouded in mystery, his fascination with numbers is well-documented; the passion led him to travel to Egypt to study Chaldean numerology for twenty-two years. Pythagoras believed that the world was built on the power of numbers and that everything and anything could be translated to numerical form, usually in single digits. The idea of assigning letters numerical values is known as the Pythagorean Number System and is used in modern numerology. The significances of numbers can also be seen in religion: 666 is associated with the beast, 888 is said to represent Jesus, and then there's the Holy Trinity. Hanukkah lasts for eight nights. In Tarot, each card is numbered, and those numbers have unique meanings. In Chinese tradition, the number four is associated with bad luck.We still use this system of numerology in an attempt to discover the hidden meanings of the world—some even use it to play the stock market. However, most employ numerology similarly to astrology—for self-discovery and prediction."
                                />
                    
                </div>
                <Typography style={{textAlign: 'center', paddingLeft: '15px', paddingRight: '10px',
                                    marginTop: '20px', marginBottom: '20px', 
                                    backgroundColor: 'transparent', fontFamily: 'khand,sans-serif',
                                    fontSize: '20px', color: '#e0515d'}}>
                    <FormattedMessage id="numPorTitle"
                                    defaultMessage="WHAT IS A NUMEROLOGY PORTRAIT?"
                                />
                    
                </Typography>                
                <div style={{color: '#fefefe', backgroundColor: 'transparent',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem',
                                            fontWeight: '400', width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)',
                                            textAlign: 'center', position: 'relative', paddingLeft: '15px', paddingRight: '10px'
                                }}>
                        <FormattedMessage id="numPorDesc1"
                                    defaultMessage="Similar to an astrological natal chart, a numerology portrait is your personalized guide to life. It reveals your strengths, weaknesses, and who you could become. Think of it as a mystic cheat-sheet. Unlike a natal chart, which uses the exact time, place, and day of birth to accurately calculate your portrait, numerology skews a bit more simple. A numerology portrait—also known as numerology chart—consists of only six numbers: three numbers calculated from your actual date of birth (your birth number, life path number, and attitude number), and three numbers pulled from the letters of your name (your soul's urge, personality number, and power number)."
                                />
                        
                        <br></br>
                        <br></br>
                </div>
                <div style={{color: '#fefefe', backgroundColor: 'transparent',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem',
                                            fontWeight: '400', width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)',
                                            textAlign: 'center', position: 'relative', paddingLeft: '15px', paddingRight: '10px'}}> 
                        <FormattedMessage id="numPorDesc2"
                                    defaultMessage="While each of these numbers and positions has special meanings, the most important number in your portrait will be your life path number. To calculate your life path number, add every single number of your birthday—day, month, and year of birth—into a single digit. This number is important because it describes the path you must take in order to find fulfillment in life. It describes who you are at your core, and who you might become if you live your full potential—similar to your sun sign in astrology."
                                />
                        
                        <br></br>
                        <br></br>
                </div>
                <div style={{color: '#fefefe', backgroundColor: 'transparent',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem',
                                            fontWeight: '400', width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)',
                                            textAlign: 'center', position: 'relative', paddingLeft: '15px', paddingRight: '10px'}}>
                            <FormattedMessage id="therearesix"
                                    defaultMessage="There are six important numbers in your numerology portrait or numerology chart."
                                />                    
                            
                        <br></br>
                        <FormattedMessage id="theyareyour"
                                    defaultMessage="They are your:"
                                />
                            <br></br><br></br>
                            <FormattedMessage id="num1"
                                    defaultMessage="1. SOUL'S URGE INNER DESIRES, WHAT MAKES YOUR SOUL HAPPY."
                                /><br></br>
                            <FormattedMessage id="num2"
                                    defaultMessage="2. PERSONALITY NUMBER THE ASPECTS OF YOUR CHARACTER THAT YOU SHOW TO OTHERS."
                                /><br></br>
                            <FormattedMessage id="num3"
                                    defaultMessage="3. POWER NUMBER THE STRENGTHS OF YOUR CHARACTER."
                                /><br></br>
                            <FormattedMessage id="num4"
                                    defaultMessage="4. BIRTHDAY NUMBER HOW OTHERS SEE YOU AT FIRST GLANCE."
                                /><br></br>
                            <FormattedMessage id="num5"
                                    defaultMessage="5. LIFE PATH NUMBER THE PATH YOU MUST TAKE IN LIFE; YOUR IDENTITY AND THE CORE OF WHO YOU ARE."
                                /><br></br>
                            <FormattedMessage id="num6"
                                    defaultMessage="6. ATTITUDE NUMBER ATTITUDE TOWARD LIFE."
                                />
                            <br></br>
                </div>
                        <Typography style={{textAlign: 'center', paddingLeft: '15px', paddingRight: '10px',
                                            marginTop: '20px', marginBottom: '20px',
                                            backgroundColor: 'transparent', fontFamily: 'khand,sans-serif',
                                            fontSize: '20px', color: '#e0515d'}}>
                            <FormattedMessage id="sowhatkindof"
                                    defaultMessage="SO, WHAT KIND OF MATH AM I DOING?"
                                />
                        </Typography>
                        <div>
                            <div style={{width: '25%'}}>
                            </div>    
                            <div style={{ color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem',
                                            fontWeight: '400',width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)',
                                            textAlign: 'center', position: 'relative', paddingLeft: '15px', paddingRight: '10px' }}>
                                                <FormattedMessage id="mathDesc"
                                    defaultMessage="Despite all this talk of numbers and Pythagoras, numerology is fairly simple. In fact, all of the math required can be done on a calculator—or even using your fingers. Modern numerology uses natural, or fadic, addition to calculate numbers; this means that all values will be added until a single number is reached. For example, if the numbers of your birth date add up to 36, the next step is to add 3 and 6 together, for a total of 9. That would be your number."
                                />
                                                <br></br>
                                                <br></br>
                                                <FormattedMessage id="quickGuide"
                                    defaultMessage="Here is a quick guide of the energies associated with your core numbers one through nine:"
                                />
                                                <br></br>
                                                <br></br>
                            </div>
                            <div style={{width: '25%'}}>
                            </div> 
                        </div>  
                    <div>
                        <div style={{width: '25%'}}>
                        </div> 
                        <div>
                            <div style={{color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem',
                                            fontWeight: '400', width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)',
                                            textAlign: 'center', position: 'relative', paddingLeft: '15px', paddingRight: '10px'}}>
                                <div>
                                    <img src={energy_number_relation} style={{width: '100%', height: 'auto', marginBottom: '20px'}}/>
                                </div>
                            </div>
                        </div>    
                        <div style={{width: '25%'}}>
                        </div> 
                    </div>
                        <div>
                            <div style={{width: '25%'}}>
                            </div>    
                            <div style={{ color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem',
                                            fontWeight: '400', width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)',
                                            textAlign: 'center', position: 'relative', paddingLeft: '15px', paddingRight: '10px'}}>
                                                <FormattedMessage id="quickdesc"
                                    defaultMessage="There are also master numbers—11, 22, 33—that show up in life path numbers, but we'll get to those later. If you come across a master number in any position that is not the life path number, reduce it down to a single number—but keep in mind you that you'll feel a powerful vibration of that number in whatever position it's in."
                                />
                                                <br></br>
                                                <br></br><br></br><br></br><br></br>
                            </div>
                            <div style={{width: '25%'}}>
                            </div> 
                        </div>  
        </div>
        )}
    }

export default Numerology;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/numerology/numerology.js